"use client";

import { useEffect, useState } from "react";

export function useCompactHeader(compactAfter = 120, expandBefore = 24) {
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    let frame = 0;
    let current = false;

    const update = () => {
      frame = 0;
      const next = current
        ? window.scrollY > expandBefore
        : window.scrollY >= compactAfter;

      if (next !== current) {
        current = next;
        setCompact(next);
      }
    };

    const scheduleUpdate = () => {
      if (frame === 0) {
        frame = window.requestAnimationFrame(update);
      }
    };

    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    scheduleUpdate();

    return () => {
      window.removeEventListener("scroll", scheduleUpdate);
      if (frame !== 0) {
        window.cancelAnimationFrame(frame);
      }
    };
  }, [compactAfter, expandBefore]);

  return compact;
}
